export default __webpack_public_path__ + "static/media/bluerec.38f93f92.svg";